/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type CustomerStatusEnum = 'E' | 'Q' | 'I' | '11184809';

export const CustomerStatusEnum = {
  E: 'E' as CustomerStatusEnum,
  Q: 'Q' as CustomerStatusEnum,
  I: 'I' as CustomerStatusEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as CustomerStatusEnum
};
